<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <!-- <el-form-item label="编号：" prop="id">
            <el-input v-model="query.id" placeholder="请输入编号" size="small" />
          </el-form-item> -->
          <el-form-item label="标题：" prop="advertisingTitle">
            <el-input v-model="query.advertisingTitle" placeholder="请输入标题" size="small" />
          </el-form-item>
          <el-form-item label="是否限制时间：">
            <el-select v-model="query.timeLimit" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="限制" :value="1"></el-option>
              <el-option label="不限制" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上下架时间：">
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.advertisingStatus" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="上架" :value="1"></el-option>
              <el-option label="下架" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <!-- 【项目落地】专属页：展示位置恒为 4，没有位置 Tab。
             共用的【广告位】页才有 首页/开屏页/课程 的切换。 -->
        <div></div>
        <div class="btn-box">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini" @click="handleClean">清除缓存</el-button>
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item :command="beforeHandleCommand(row,2)">批量下架</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,1)">批量上架</el-dropdown-item> -->
              <el-dropdown-item :command="beforeHandleCommand(row,3)">批量删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新建</el-button>
        </div>
      </div>

      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange" :key="activeName">
        <el-table-column type="selection" width="50" />
        <el-table-column label="编号" prop="id" align="center" fixed/>
        <el-table-column label="标题" prop="advertisingTitle" align="center" fixed/>
        <el-table-column label="图片" prop="advertisingUrl" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 50px; height: 50px" :src="row.advertisingUrl" :preview-src-list="[row.advertisingUrl]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="跳转类型" prop="name" align="center" v-if="activeName=='2'">
          <template slot-scope="{row}">
            {{row.jumpType==1?'外链':'内链'}}
          </template>
        </el-table-column>
        <el-table-column label="商品类型" prop="name" align="center" >
          <template slot-scope="{row}">
            {{row.advertisingType | setType}}
          </template>
        </el-table-column>
        <el-table-column label="内容/地址" prop="" align="center" v-if="activeName=='2'" width="150">
          <template slot-scope="{row}">
            <span v-if="row.jumpType==1">{{row.jumpUrl}}</span>
            <span v-else>{{row.advertisingType==3?row.courseId:row.goodsId}} {{row.advertisingType==3?row.courseName:row.goodsName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="内容" prop="" align="center" v-else width="150">
          <template slot-scope="{row}">
            {{row.advertisingType==3?row.courseId:row.goodsId}} {{row.advertisingType==3?row.courseName:row.goodsName}}
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="name" align="center" >
          <template slot-scope="{row}">
            <el-input v-model.number="row.orderNo" placeholder="请输入" @change="handleOrderNo(row)" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="是否限制时间" prop="timeLimit" align="center">
          <template slot-scope="{row}">
            {{row.timeLimit == 1?'限制':'不限制'}}
          </template>
        </el-table-column>
        <el-table-column label="上下架时间" prop="orderNo" sortable="custom" align="center" width="180">
          <template slot-scope="{row}">
            <span v-if="row.timeLimit==1">{{row.startTime}} ~ {{row.endTime}}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="状态" prop="advertisingStatus" align="center" width="120">
          <template slot-scope="{row}">
            <el-switch v-model="row.advertisingStatus" :active-value="1" :inactive-value="0" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operatedName" align="center" />
        <el-table-column label="操作" align="center" fixed="right" width="130">
          <template slot-scope="{row}"  >
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <banner-add ref="bannerAdd" @created="doQueryList({})" />
  </div>
</template>

<script>
import bannerAdd from './add'
import sysBannerApi from '@/api/config/sysBanner'
import Pagination from '@/components/Pagination'

// 展示位置 4 = 项目落地资料包专区页顶部 banner（1首页 2开屏页 3课程）。
// 数据仍在 advertising_position 表，只是 display_position 固定为 4，尺寸口径与首页一致 710x320。
const DISPLAY_POSITION_PROJECT_LANDING = "4"

export default {
  components: {
    Pagination,
    bannerAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10
      },
      selectItems: [],
      activeName: DISPLAY_POSITION_PROJECT_LANDING,
      dateTime:null
    }
  },
  filters:{
    setType(val){
      switch (val) {
        case 1:
          return "商品管理";
        case 2:
          return "积分商品";
        case 3:
          return "课程";
        case 4:
          return "秒杀商品";
        default:
          return val;
      }
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    // 清除缓存
    async handleClean(){
      await sysBannerApi.delCache(this.activeName*1)
      this.$common.showMsg('success', '清除成功')
      this.doQueryList({ pageNo: 1 })
    },
    // 修改排序
    async handleOrderNo(row){
      console.log('row: ',row);
      let query={
        id:row.id,
        orderNo:row.orderNo
      }
      const {data} = await sysBannerApi.setOrderNo(query)
    },
    /**
     * 状态修改
     */
    changeSwitch(row) {
      console.log('row',row.id)
      let obj={
        id:row.id,
        advertisingStatus: row.advertisingStatus,
      }
      // obj.tagUpdateDTOList=row.customerTagList.map(i=>({id:i.id,groupId:row.customerTagGroup.id,name:i.name,tagState:1}))
      // return
      sysBannerApi.setStatus({ ...obj }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    handleFilter(){
      this.query = {}
      this.dateTime=[]
      this.doQueryList({ pageNo: 1 ,pageSize: 10})
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query={...this.query}
      if(this.dateTime && this.dateTime.length){
        query.startTime=this.dateTime[1]
        query.endTime=this.dateTime[0]
      }
      query.displayPosition=this.activeName*1
      // this.query.orderTimeStart = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      // this.query.orderTimeEnd = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      this.listLoading = true
      return sysBannerApi.fetchList(query)
        .then(({data}) => {
          console.log("data: ",data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 2)
      } else if (command.command === 3) {
        this.handleDeleteBatch()
      }
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => sysBannerApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择数据')
        return
      }
      return this.$common.confirm(`当前选择${this.selectItems.length}条数据，是否确认删除`)
        .then(() => sysBannerApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    // changeSwitch(row) {
    //   sysBannerApi.setIsEnableExpress({ id: row.id, isEnable: row.isEnable }).then(() => {
    //     this.$common.showMsg('success', '操作成功')
    //   })
    // },
    /**
     * 打开新建表单
     */
    handleCreate() {
      // 本页专属：新建的 banner 一律落在【项目落地】展示位
      this.$refs.bannerAdd.handleCreate(DISPLAY_POSITION_PROJECT_LANDING)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.bannerShow.handleShow(row.id)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.bannerAdd.handleUpdate(row)
    }
  }
}
</script>
